import Vue from 'vue'
import VueIziToast from 'vue-izitoast'
Vue.use(VueIziToast)



// WEBPACK FOOTER //
// ./src/bibliotecas/vue/vuetoastr.js